module.exports = __webpack_public_path__ + "92e24fbbfa9f8ec298e3d343a1e001fc.svg";